import React from 'react'
import { BRAND_DISPLAY_NAME } from 'app-constants'
import { STATICS } from 'statics'
import './style.scss'

export function PasswordLogo() {
  return (
    <img className='password-logo' src={STATICS.LOGO_HEADER} alt={`${BRAND_DISPLAY_NAME} logo`} />
  )
}
